/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["jquery", "underscore", "utils/timer", "utils/keys"], function ($, _, timer, keys) {
  var DELAY = 500;

  var TooltipRole = function (containerEl, options) {
    var that = this;

    options = options || {};
    this.selector = options.selector;

    this.$containerEl = $(containerEl);
    this.$containerEl.on("keydown.mb-role-tooltip", function (e) { that.navigatingWithTab = e.which === keys.tab; });
    this.$containerEl.on("mousedown.mb-role-tooltip", function (e) { that.navigatingWithTab = false; });
    this.$containerEl.on("focusin.mb-role-tooltip", this.selector, function (e) { that.updateTooltipWithFocus(e); });
    this.$containerEl.on("keydown.mb-role-tooltip", function (e) {
      if(e.key === "Escape" || e.keyCode === 27) {
        var $el = $(e.target);
        that.hideTooltip(e, that.waitFor, $el);
      }
    });
    $(document.body).on("focusin.mb-role-tooltip", function (e) { 
        var $el = $(e.target);
        if (!$el.is(that.selector)) {
          $el = $(e.target).closest(that.selector);
        }

        if (that.$el && $el[0] !== that.$el[0]) {
          that.hideTooltip(e, that.waitFor, $el);
        }
    });
  };

  TooltipRole.prototype.updateTooltipWithFocus = function (e) {
    var $el = $(e.target).closest(this.selector);

    if (!this.$el || this.$el[0] !== $el[0]) {
      this.hideTooltip(e, this.waitFor || "blur");
      if (this.navigatingWithTab) this.showTooltip(e, "blur", $el);
    }
  };

  TooltipRole.prototype.showTooltip = timer.delayedThrottled(function (e, waitFor, $el) {
    $el = $el || $(e.currentTarget);
    if (!$el.is(this.selector)) {
      $el = $(e.target).closest(this.selector);
    }

    if (this.$el && this.$el[0] !== $el[0]) {
      this.hideTooltip(e, this.waitFor);
    }
    if (this.waitFor) return;

    this.$el = $el;
    this.$tip = $('#' + this.$el.attr('aria-describedby'));
    this.$tip.removeAttr("aria-hidden");
    this.waitFor = waitFor;
  }, DELAY);

  TooltipRole.prototype.hideTooltip = function (e, type, $el) {
    $el = $el || $(e.target);

    this.showTooltip.abort();
    if (this.$tip && (!this.waitFor || this.waitFor === type)) {
      this.$tip.attr("aria-hidden", "true");
      delete this.$el;
      delete this.waitFor;
    }
  };

  TooltipRole.prototype.destroy = function () {
    $(document.body).off(".mb-role-tooltip");
    this.$containerEl && this.$containerEl.off(".mb-role-tooltip");

    delete this.$containerEl;
    delete this.selector;
  }

  return TooltipRole;
});
